import followUpAutomationsAPI from '../../api/followUpAutomations';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getAutomations: $state => $state.records,
  getEnabledAutomations: $state => $state.records.filter(a => a.enabled),
  getAutomation: $state => id => $state.records.find(a => a.id === id),
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await followUpAutomationsAPI.get();
      commit('SET_AUTOMATIONS', response.data.payload);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, automationData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await followUpAutomationsAPI.create(automationData);
      commit('ADD_AUTOMATION', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...automationData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await followUpAutomationsAPI.update(id, automationData);
      commit('UPDATE_AUTOMATION', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await followUpAutomationsAPI.delete(id);
      commit('DELETE_AUTOMATION', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_AUTOMATIONS($state, automations) {
    $state.records = automations;
  },
  ADD_AUTOMATION($state, automation) {
    $state.records.push(automation);
  },
  UPDATE_AUTOMATION($state, automation) {
    const index = $state.records.findIndex(a => a.id === automation.id);
    if (index !== -1) {
      $state.records.splice(index, 1, automation);
    }
  },
  DELETE_AUTOMATION($state, id) {
    $state.records = $state.records.filter(a => a.id !== id);
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
